import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** @jsx jsx */
import { useEffect, useState } from 'react';
import ProjectCard from './ProjectCard';
import Pagination from '@mui/material/Pagination';
export default function ProjectsList(props) {
    const [page, setPage] = useState(1);
    const perPage = 6;
    const handlePageChange = (event, value) => {
        var _a;
        (_a = document.getElementById("projectsList")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        setPage(value);
    };
    useEffect(() => {
        setPage(1);
    }, [props.projects]);
    return (_jsx("div", Object.assign({ id: "projectsList", className: 'd-flex flex-column mt-4' }, { children: (() => {
            if (props.projects.length != 0) {
                return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: 'project-grid mt-2' }, { children: props.projects.map((project, index) => {
                                if (index >= (perPage * (page - 1)) && index < (perPage * (page))) {
                                    return (_jsx(ProjectCard, { project: project }, project.ID));
                                }
                            }) })), _jsx(Pagination, { className: "pagination d-flex justify-content-center w-100", count: props.projects.length % perPage == 0 ? Math.floor(props.projects.length / perPage) : Math.floor(props.projects.length / perPage + 1), variant: "outlined", shape: "rounded", onChange: handlePageChange })] }));
            }
            else {
                return (_jsx("div", Object.assign({ className: "w-100 my-5 py-5 justify-content-center no-project-found-div" }, { children: "Aucune fiche projet ne correspond \u00E0 votre recherche" })));
            }
        })() })));
}
